export const SuccessModal = ({ name, onClose }) => {
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/40 backdrop-blur-sm"
      onClick={(e) => e.target === e.currentTarget && onClose()}
      role="dialog"
      aria-modal="true"
      aria-labelledby="success-modal-title"
    >
      <div className="bg-white rounded-2xl shadow-xl max-w-md w-full p-8 text-center">
        <div className="mx-auto w-14 h-14 rounded-full bg-emerald-500/10 flex items-center justify-center mb-6">
          <svg
            className="w-7 h-7 text-emerald-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M5 13l4 4L19 7" />
          </svg>
        </div>
        <h2
          id="success-modal-title"
          className="text-xl font-semibold text-gray-900 mb-2"
        >
          Message sent
        </h2>
        <p className="text-gray-500 text-sm leading-relaxed mb-8">
          Thank you{name && typeof name === "string" ? `, ${name}` : ""}, for reaching out to Luupli. We've received your message and
          appreciate your input. We'll be in touch soon.
        </p>
        <button
          type="button"
          onClick={onClose}
          className="w-full py-3 px-4 rounded-xl bg-gray-900 text-white text-sm font-medium hover:bg-gray-800 transition-colors"
        >
          Done
        </button>
      </div>
    </div>
  );
};
